'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Snackbar = require('material-ui/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Snackbar = function (_PureComponent) {
  _inherits(Snackbar, _PureComponent);

  function Snackbar() {
    _classCallCheck(this, Snackbar);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  } // componentDidUpdate(prevProps, prevState) {
  //   const keys = Object.keys(this.props);
  //   keys.map(key => {
  //     const value = this.props[key];
  //     const prevValue = prevProps[key];
  //     if (value !== undefined && prevValue !== undefined && value !== prevValue) {
  //       console.log("Snackbar componentDidUpdate value !== prevValue / ", key, value, prevValue);
  //     }
  //   });
  //   super.componentDidUpdate && super.componentDidUpdate(prevProps, prevState);
  // }


  Snackbar.prototype.render = function render() {
    if (typeof window === "undefined") {
      return null;
    }

    var _props = this.props,
        message = _props.message,
        close = _props.close,
        opened = _props.opened,
        error = _props.error,
        other = _objectWithoutProperties(_props, ['message', 'close', 'opened', 'error']);

    return _reactDom2.default.createPortal(_react2.default.createElement(_Snackbar2.default, _extends({
      open: opened // autoHideDuration={errorDelay}
      // onClose={event => this.onCloseError(error)}
      // SnackbarContentProps={{
      //   // 'aria-describedby': 'snackbar-fab-message-id',
      //   // className: classes.snackbarContent,
      // }}
      ,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      message: _react2.default.createElement('span', null, message),
      action: _react2.default.createElement(_react.Fragment, null, close ? _react2.default.createElement(_Button2.default, {
        color: 'primary',
        variant: 'raised',
        size: 'small',
        onClick: function onClick(event) {
          event.stopPropagation();
          event.preventDefault();
          close && close(error);
        }
      }, 'Close') : null),
      style: {
        // position: "absolute",
        // width: "100%",
        // height: "100%",
        // margin: 0,
        // padding: 0,
        // bottom: 0,
        zIndex: 3000
      }
    }, other)), window.document.body);
  };

  return Snackbar;
}(_react.PureComponent);

exports.default = Snackbar;
Snackbar.propTypes = process.env.NODE_ENV !== "production" ? {
  error: _propTypes2.default.object,
  opened: _propTypes2.default.bool.isRequired,
  message: _propTypes2.default.string.isRequired,
  close: _propTypes2.default.func
} : {};
module.exports = exports['default'];